export default __webpack_public_path__ + "static/media/pic_payment_success.d3ff6d50.svg";